import { FilterConfig } from '../../shared/models/filter-config.model';
import { PilexosUser } from '../../shared/models/pilexos-user.model';
import { SchoolFeatures } from '../../schools/models/school-features.model';

export type ReportAccessMode = 'standardSchool' | 'odaSchool' | 'examiner' | 'admin' | 'default';

export type ReportAccessFilterKey =
    | 'examiner'
    | 'flightSchool'
    | 'flightInstructor'
    | 'checkrideType'
    | 'attemptClassification'
    | 'dateRange'
    | 'testType'
    | 'acsTest';

export type ReportAccessPivotDimensionKey =
    | 'examiner'
    | 'checkrideType'
    | 'attemptClassification'
    | 'testType'
    | 'flightSchool'
    | 'flightInstructor'
    | 'acsTest';

export type ReportAccessUiKey = ReportAccessFilterKey | ReportAccessPivotDimensionKey;

export interface ReportAccessConfig {
    mode: ReportAccessMode;
    pilexosUser: PilexosUser;
    schoolFeatures?: SchoolFeatures | null;
    isSchoolUser: boolean;
    isOdaSchool: boolean;
    isExaminer: boolean;
    isPilexosAdmin: boolean;
    hideFilterKeys: ReportAccessFilterKey[];
    hidePivotDimensionKeys: ReportAccessPivotDimensionKey[];
    labelOverrides: Partial<Record<ReportAccessUiKey, string>>;
    autoFilterValues: {
        checkRideOwnershipTypeId?: number;
        flightSchoolOrganizationId?: number;
        pilotExaminerId?: number;
    };
    adminExperienceDeferred?: boolean;
}

export function applyReportAccessToFilterConfigs(filterConfigs: FilterConfig[], accessConfig: ReportAccessConfig): FilterConfig[] {
    return filterConfigs
        .filter(filterConfig => {
            const accessKey = filterConfig.accessKey as ReportAccessFilterKey | undefined;
            return !accessKey || !accessConfig.hideFilterKeys.includes(accessKey);
        })
        .map(filterConfig => {
            const accessKey = filterConfig.accessKey as ReportAccessFilterKey | undefined;
            if (!accessKey) {
                return filterConfig;
            }

            const overrideLabel = accessConfig.labelOverrides[accessKey];
            if (!overrideLabel) {
                return filterConfig;
            }

            return {
                ...filterConfig,
                label: overrideLabel
            };
        });
}
